"use client";

import Image from "@/components/AppImage";
import { useCallback, useEffect, useId, useState } from "react";
import { createPortal } from "react-dom";
import { BsStars, BsX } from "react-icons/bs";
import add_new from "/public/images/add-new.png";
import blockchain_card from "/public/images/blockchain-card.png";
import paylio_card from "/public/images/paylio-card.png";
import paypal_card from "/public/images/paypal-card.png";
import visa_card from "/public/images/visa-card.png";

const METHODS = [
  { id: "visa", label: "Visa", image: visa_card, alt: "Visa" },
  { id: "paylio", label: "Paylio", image: paylio_card, alt: "Paylio" },
  { id: "paypal", label: "PayPal", image: paypal_card, alt: "PayPal" },
  {
    id: "blockchain",
    label: "Crypto wallet",
    image: blockchain_card,
    alt: "Blockchain wallet",
  },
];

const PaymentMethodTab = () => {
  const titleId = useId();
  const descId = useId();
  const [open, setOpen] = useState(false);
  const [methodLabel, setMethodLabel] = useState("");
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const showComingSoon = useCallback((label) => {
    setMethodLabel(label);
    setOpen(true);
  }, []);

  const close = useCallback(() => setOpen(false), []);

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape") close();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
    };
  }, [open, close]);

  const modal = mounted ? (
    createPortal(
      <div
        className={`pmcs-overlay${open ? " pmcs-overlay--open" : ""}`}
        role="presentation"
        onClick={(e) => {
          if (e.target === e.currentTarget) close();
        }}
      >
        <div
          className="pmcs-overlay__panel"
          role="dialog"
          aria-modal="true"
          aria-labelledby={titleId}
          aria-describedby={descId}
        >
          <div className="pmcs-overlay__inner">
            <button
              type="button"
              className="pmcs-overlay__close"
              onClick={close}
              aria-label="Close"
            >
              <BsX size={22} aria-hidden={true} />
            </button>
            <div className="pmcs-overlay__badge">
              <BsStars aria-hidden={true} />
              Coming soon
            </div>
            <div className="pmcs-overlay__icon-wrap" aria-hidden={true}>
              <BsStars />
            </div>
            <h2 id={titleId} className="pmcs-overlay__title">
              <span>{methodLabel}</span> is on the way
            </h2>
            <p id={descId} className="pmcs-overlay__text">
              We&apos;re finishing a secure, seamless way to connect{" "}
              <strong>{methodLabel}</strong> to your Paylio workspace. Check
              back soon — you&apos;ll be the first to know.
            </p>
            <button type="button" className="pmcs-overlay__cta" onClick={close}>
              Got it
            </button>
          </div>
        </div>
      </div>,
      document.body
    )
  ) : null;

  return (
    <>
      {modal}
      <div
        className="tab-pane pb-120 fade"
        id="payment"
        role="tabpanel"
        aria-labelledby="payment-tab"
      >
        <div className="card-area">
          <h6>ACH bank &amp; Polygon wallets</h6>
          <p className="mdr small mb-3">
            Inbound ACH only · default credit USDC (Polygon) · optional POL
            auto-convert
          </p>
          <div className="card-content d-flex flex-wrap">
            {METHODS.map(({ id, label, image, alt }) => (
              <div key={id} className="single-card">
                <button
                  type="button"
                  className="reg w-100"
                  onClick={() => showComingSoon(label)}
                >
                  <Image src={image} alt={alt} className="w-100" />
                </button>
              </div>
            ))}
            <div className="single-card">
              <button
                type="button"
                className="reg w-100"
                onClick={() => showComingSoon("New payment methods")}
              >
                <Image src={add_new} alt="Add payment method" className="w-100" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentMethodTab;
